{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Ny melding",
  "chat.scrollToBottom": "Scroll to bottom",
  "messagefeedback.thumbDown": "Dårlig respons",
  "messagefeedback.thumbUp": "Bra respons",
  "promptfield.aiDisclaimer": "Responses are generated using AI, and may be inaccurate. Check before using.",
  "promptfield.aiUserGuidlines": "AI User Guidelines",
  "promptfield.attachments": "Attachments",
  "promptfield.insertButton": "Add",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Klar til å komme i gang? Still et spørsmål, del en idé eller legg til en oppgave.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Send",
  "promptfield.uploading": "Uploading",
  "responsestatus.loading": "Laster inn",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Start recording",
  "voicebutton.stopListening": "Stop recording",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
